import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {SimpleDate} from "../utils/simple-date";
import {Observable} from "rxjs/Observable";


export enum DisposalType {
  AVAILABLE = 'AVAILABLE',
  NOT_AVAILABLE = 'NOT_AVAILABLE'
}

@Injectable()
export class DisposalsService {

  constructor(private http: HttpClient) {
  }

  createDisposal(type: DisposalType, start: SimpleDate, end: SimpleDate): Observable<any> {
    return this.http.post('/disposals', {
      type: type,
      start: start.toJSON(),
      end: end.toJSON(),
    })
  }

  makeTentative(start: SimpleDate, end: SimpleDate): Observable<any> {
    return this.http.put('/disposals', {
      start: start.toJSON(),
      end: end.toJSON(),
    })
  }

  removeDisposal(disposalId: number): Observable<any> {
    return this.http.delete(`/disposals/${disposalId}`);
  }
}



// WEBPACK FOOTER //
// /builds/ulalachef/ulalachef-dashboard/src/app/services/disposals.service.ts